import React from 'react';
import './Navbar.css';
import { Link } from 'react-router-dom';




const Navbar = () => {
    return ( 


    <>


<section class="navbar custom-navbar navbar-fixed-top" role="navigation">
          <div class="container">

               <div class="navbar-header">
                    <button class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                         <span class="icon icon-bar"></span>
                         <span class="icon icon-bar"></span>
                         <span class="icon icon-bar"></span>
                    </button>

                
                    <a href="index.html" class="navbar-brand main-logo">
                    <img src={"images/senlogo-white.png"} alt="" className='logo-moblie'/>
                    <img src={"images/senlogo-black.png"} alt="" className='logo-desktop'/>
                    
                    </a>
               </div>

        
               <div class="collapse navbar-collapse">
                    <ul class="nav navbar-nav navbar-nav-first">
                         <li><a href="#home" class="smoothScroll">Home</a></li>
                         <li><a href="#about" class="smoothScroll">About</a></li>
                         <li><a href="#blog" class="smoothScroll">Blog</a></li>
                         <li><a href="#work" class="smoothScroll">Our Work</a></li>
                         <li><a href="#contact" class="smoothScroll">Contacts</a></li>
                    </ul>

                    <ul class="nav navbar-nav navbar-right">
                         <li><a href="lu#"><i class="fa-solid fa-cart-shopping"></i></a></li>
                         <li><a href="lu#"><i class="fa-solid fa-user"></i></a></li>
                         <li><a href="lu#"><i class="fa-solid fa-phone"></i></a></li>
                         <li class="section-btn"><Link to="/account"> Sign in / Join</Link></li>
                    </ul>
               </div>

          </div>
     </section>


    </> 
    
    
    
    );
}
 
export default Navbar;